var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { isEqual, partition } from 'lodash';
import { mergeSceneGraphNodes } from './merge-scene-graph-nodes';
function mergeAnonymousGraphs(original, additions) {
    // i know that original and additions are collections of anonymous nodes
    // for each addition, 
    // is the addition equal to an original node?
    // if it is not, append it
    return additions.reduce(function (acc, addition) {
        var e_1, _a;
        try {
            for (var original_1 = __values(original), original_1_1 = original_1.next(); !original_1_1.done; original_1_1 = original_1.next()) {
                var node = original_1_1.value;
                if (!isEqual(node, addition)) {
                    acc.push(addition);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (original_1_1 && !original_1_1.done && (_a = original_1.return)) _a.call(original_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return acc;
    }, original);
}
function mergeNonAnonymousGraphs(original, additions) {
    var originalSceneGraphsDict = original.reduce(function (acc, root) {
        acc[root.objectId] = root;
        return acc;
    }, {});
    var newSceneGraphsDict = additions.reduce(function (acc, root) {
        // if a scene graph id doesn't exist, include it
        if (acc.nodes[root.objectId] === undefined) {
            acc.nodes[root.objectId] = root;
            return acc;
        }
        // if a scene graph exists, and its not the same, merge it with the original
        if (!isEqual(root, acc.nodes[root.objectId])) {
            var merged = mergeSceneGraphNodes(acc.nodes[root.objectId], root);
            acc.nodes[root.objectId] = merged.root[0];
            acc.graphsMerged.push(root.objectId);
            acc.objectIdsUniqueToNew[root.objectId] = merged.objectIdsUniqueToNew;
            acc.objectIdsUniqueToOriginal[root.objectId] = merged.objectIdsUniqueToOriginal;
        }
        // if a scene graph exists, and its the same
        // do nothing
        return acc;
    }, {
        nodes: originalSceneGraphsDict,
        graphsMerged: [],
        objectIdsUniqueToNew: {},
        objectIdsUniqueToOriginal: {}
    });
    // convert from dict back to array
    var newSceneGraph = Object.keys(newSceneGraphsDict.nodes).reduce(function (acc, rootId) {
        acc.push(newSceneGraphsDict.nodes[rootId]);
        return acc;
    }, []);
    return {
        newSceneGraph: newSceneGraph,
        graphsMerged: newSceneGraphsDict.graphsMerged,
        objectIdsUniqueToNew: newSceneGraphsDict.objectIdsUniqueToNew,
        objectIdsUniqueToOriginal: newSceneGraphsDict.objectIdsUniqueToOriginal
    };
}
export function mergeSceneGraphs(originalGraph, additions) {
    // need to handle anonymous objects.
    // anonymous objects need to be combined separately, and merged with the rest
    var partitioner = function (root) { return root.objectId !== undefined; };
    // handle anonymous nodes
    var _a = __read(partition(originalGraph, partitioner), 2), originalNodesWithId = _a[0], originalAnonymousNodes = _a[1];
    var _b = __read(partition(additions, partitioner), 2), additionsWithId = _b[0], additionsAnonymous = _b[1];
    // take additions with id and push them into originals with ids 
    var combinedGraphsWithNoIds = mergeAnonymousGraphs(originalAnonymousNodes, additionsAnonymous);
    var _c = mergeNonAnonymousGraphs(originalNodesWithId, additionsWithId), newSceneGraph = _c.newSceneGraph, graphsMerged = _c.graphsMerged, objectIdsUniqueToNew = _c.objectIdsUniqueToNew, objectIdsUniqueToOriginal = _c.objectIdsUniqueToOriginal;
    return {
        sceneGraph: __spread(combinedGraphsWithNoIds, newSceneGraph),
        graphsMerged: graphsMerged,
        objectIdsUniqueToNew: objectIdsUniqueToNew,
        objectIdsUniqueToOriginal: objectIdsUniqueToOriginal
    };
}
function makeUpdateDict(graphsMerged, uniqueObjectIds) {
    var e_2, _a, e_3, _b;
    var updateDict = {};
    try {
        for (var graphsMerged_1 = __values(graphsMerged), graphsMerged_1_1 = graphsMerged_1.next(); !graphsMerged_1_1.done; graphsMerged_1_1 = graphsMerged_1.next()) {
            var rootId = graphsMerged_1_1.value;
            var objectIds = Object.keys(uniqueObjectIds[rootId]);
            try {
                for (var objectIds_1 = __values(objectIds), objectIds_1_1 = objectIds_1.next(); !objectIds_1_1.done; objectIds_1_1 = objectIds_1.next()) {
                    var objectId = objectIds_1_1.value;
                    updateDict[objectId] = false;
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (objectIds_1_1 && !objectIds_1_1.done && (_b = objectIds_1.return)) _b.call(objectIds_1);
                }
                finally { if (e_3) throw e_3.error; }
            }
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (graphsMerged_1_1 && !graphsMerged_1_1.done && (_a = graphsMerged_1.return)) _a.call(graphsMerged_1);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return updateDict;
}
// since we merged scene graphs, we must update show, select, and pickThroughObjects
// objects that are new additions from another model's scene graph must be explicity
// set to false in show, select, pickthrough objects.  i.e. they are not a part of this scene.
// preserve the original contents of show, select, pickthrough objects
// an updateDict is all the objectIds to set to false.
export function updateChapterShowSelectPickThroughObjects(chapters, graphsMerged, uniqueObjectIds) {
    var updateDict = makeUpdateDict(graphsMerged, uniqueObjectIds);
    return chapters.map(function (chapter) {
        return __assign({}, chapter, { showObjects: __assign({}, chapter.showObjects, updateDict), selectObjects: __assign({}, chapter.selectObjects, updateDict), pickThroughObjects: __assign({}, chapter.pickThroughObjects, updateDict) });
    });
}
